import { onReady } from '../lib/on-ready.js';

function initCardBanners() {
    document.querySelectorAll('.card-banner-component').forEach((component) => {
        const container = component.querySelector('.card-banner-scroll-container');
        const track = component.querySelector('.scroll-track');
        const thumb = component.querySelector('.scroll-thumb');
        if (!container || !track || !thumb) {
            return;
        }

        function updateThumb() {
            const { scrollLeft, scrollWidth, clientWidth } = container;
            if (scrollWidth <= clientWidth) {
                track.style.display = 'none';
                return;
            }
            track.style.display = 'block';
            const thumbWidth = (clientWidth / scrollWidth) * 100;
            const thumbLeft = (scrollLeft / (scrollWidth - clientWidth)) * (100 - thumbWidth);
            thumb.style.width = `${thumbWidth}%`;
            thumb.style.left = `${thumbLeft}%`;
        }

        let dragging = false;

        container.addEventListener('scroll', updateThumb);
        window.addEventListener('resize', updateThumb);
        track.addEventListener('click', (event) => {
            const rect = track.getBoundingClientRect();
            const clickRatio = (event.clientX - rect.left) / rect.width;
            container.scrollLeft = clickRatio * (container.scrollWidth - container.clientWidth);
        });
        thumb.addEventListener('mousedown', (event) => {
            dragging = true;
            event.preventDefault();
        });
        thumb.addEventListener('touchstart', () => {
            dragging = true;
        }, { passive: true });

        function onMove(clientX) {
            if (!dragging) {
                return;
            }
            const rect = track.getBoundingClientRect();
            const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
            container.scrollLeft = ratio * (container.scrollWidth - container.clientWidth);
        }

        document.addEventListener('mousemove', (event) => onMove(event.clientX));
        document.addEventListener('touchmove', (event) => onMove(event.touches[0].clientX));
        document.addEventListener('mouseup', () => { dragging = false; });
        document.addEventListener('touchend', () => { dragging = false; });

        updateThumb();
    });
}

onReady(initCardBanners);
